import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.match.js";
import Cookies from "js-cookie";
export function encodeCookie(name, obj) {
  var days = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 30;
  var encodeObj = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  var d = new Date();
  d.setTime(d.getTime() + 24 * 60 * 60 * 1000 * days);
  var stringObj = typeof obj !== "string" ? JSON.stringify(obj) : obj;
  var cookieValue = encodeObj ? btoa(encodeURIComponent(stringObj)) : stringObj;
  document.cookie = name + "=" + cookieValue + ";path=/;expires=" + d.toUTCString();
}
export function getCookie(name) {
  try {
    var v = document.cookie.match("(^|;) ?" + name + "=([^;]*)(;|$)");
    return v ? v[2] : null;
  } catch (e) {
    console.error(e);
    return null;
  }
}
export function decodeCookie(name) {
  try {
    var v = document.cookie.match("(^|;) ?" + name + "=([^;]*)(;|$)");
    return v ? JSON.parse(decodeURIComponent(atob(v[2]))) : null;
  } catch (e) {
    console.error(e);
    removeCookie(name);
    return null;
  }
}
export function removeCookie(name) {
  Cookies.remove(name);
}